export const formatTransactionType = (type?: string) => {
  if (!type) return '—';
  const map: Record<string, string> = {
    CASH_IN: 'Entrada',
    CASH_OUT: 'Saída',
  };
  return map[type] || type.replace(/_/g, ' ').toLowerCase().replace(/\b\w/g, (c) => c.toUpperCase());
};

export const getTransactionMethodLabel = (type: string, method: string) => {
  if (method === 'CHIPPIX_PIX') {
    return type === 'CASH_IN' ? 'Pagamento QRCode' : 'Resgate de saldo jogador';
  }
  return type === 'CASH_IN' ? 'Adição de Saldo SCPT ADMIN' : 'Retirada de saldo SCPT Admin';
};

export const formatStatusLabel = (status?: string) => {
  if (!status) return '—';
  const map: Record<string, string> = {
    SUCCESS: 'Sucesso',
    PAID: 'Pago',
    DONE: 'Concluído',
    FAILED: 'Falha',
    PENDING: 'Pendente',
  };
  return map[status] || status.replace(/_/g, ' ').toLowerCase().replace(/\b\w/g, (c) => c.toUpperCase());
};

export const getStatusColor = (status?: string) => {
  switch (status) {
    case 'SUCCESS':
    case 'PAID':
    case 'DONE':
      return 'success';
    case 'FAILED':
      return 'danger';
    case 'PENDING':
      return 'warning';
    default:
      return 'brand';
  }
};
